export interface IDashPerformance {
    centerId?: number,
    centerAlias: string,
    currentCountPendingEmrRegistration: number,
    currentMinWaitEmrRegistration: number,
    currentAvgWaitEmrRegistration: number,
    currentMaxWaitEmrRegistration: number,
    currentCountPendingHistory: number,
    currentMinWaitFinishHistory: number,
    currentAvgWaitFinishHistory: number,
    currentMaxWaitFinishHistory: number,
    currentCountPendingDisposition: number,
    currentMinWaitDisposition: number,
    currentAvgWaitDisposition: number,
    currentMaxWaitDisposition: number,
    currentCountPendingCompletion: number,
    currentMinWaitCompleted: number,
    currentAvgWaitCompleted: number,
    currentMaxWaitCompleted: number,
    countCompletedEmrRegistration: number,
    minWaitEmrRegistration: number,
    avgWaitEmrRegistration: number,
    maxWaitEmrRegistration: number,
    countCompletedHistory: number,
    minWaitFinishHistory: number,
    avgWaitFinishHistory: number,
    maxWaitFinishHistory: number,
    countCompletedDisposition: number,
    minWaitDisposition: number,
    avgWaitDisposition: number,
    maxWaitDisposition: number,
    countCompleted: number,
    minWaitCompleted: number,
    avgWaitCompleted: number,
    maxWaitCompleted: number,
    totalContacts: number,
    totalAutoRuleOuts: number,
    totalManualRuleOuts: number,
    totalSoftRuleOuts: number,
    totalExpiredRuleOuts: number,
    totalLocationRuleOuts: number,
    totalDisconnects: number,
    totalConfirmedDonations: number,
    conversionRate: number,
    conversionRatePercent: number,
    totalRuleOuts: number,
    currentCountBackLog: number,
    totalRuleOutPercent: number,
    totalAutoRuleOutPercent: number,
    totalManualRuleOutPercent: number,
    totalSoftRuleOutPercent: number,
    totalExpiredRuleOutPercent: number,
    totalLocationRuleOutPercent: number,
    totalDisconnectsPercent: number
}